module.exports = __webpack_public_path__ + "img/4-2-1-4-3-preview-instagramcampaign-e.15a43f10.jpg";